import { fetchData } from './fetchData';

import { type Product } from '../components/endpoint/types';
import { type ProductFromNetwork } from '../data/createPayoutData/types';

export async function fetchProducts(
  orgId: string,
  origin: 'disbursement' | 'collection'
) {
  return await fetchData<{ data: ProductFromNetwork[] }>(
    `/api/v2/documentation/organisations/${orgId}/products`,
    'GET',
    {},
    { origin }
  );
}

export async function fetchProduct({
  orgId,
  productId,
  schemaId
}: {
  orgId: string;
  productId: string;
  schemaId?: string;
}) {
  return await fetchData<{ data: Product }>(
    `/api/v2/documentation/organisations/${orgId}/products/${productId}`,
    'GET',
    null,
    { schema: schemaId }
  );
}
